import { DataSource } from '@client/core/data/concerns/data-source';
import { fromJson, JsonResponse } from '@client/core/data/concerns/parses-from-json';
import { Pagination } from '@client/core/http/pagination';
import { HttpResponse, HttpResponseWithMeta, PaginationResponse, SearchRequestParams } from '@client/core/http/types';
import { PropertySearch } from '@client/features/property-search/models/property-search';
import { PropertySearchLocation } from '@client/features/property-search/store/use-property-search-store';

export class PropertySearchDataSource extends DataSource {
  /**
   * @see App\Http\Controllers\PropertySearch\PropertySearchController@index
   */
  async findAll(
    ownerId: number,
    params: SearchRequestParams = {
      page: 1,
    },
  ): Promise<PaginationResponse<PropertySearch[]>> {
    const response = await this.httpClient.get<HttpResponseWithMeta<JsonResponse[], Pagination>>(
      `/workspace/${ownerId}/property-search`,
      {
        params: {
          ...params,
          page: params?.page ?? 1,
        },
      },
    );

    return {
      data: response.data.data.map((propertySearch) => fromJson(PropertySearch, propertySearch)),
      pagination: fromJson(Pagination, response.data.meta),
    };
  }

  /**
   * @see App\Http\Controllers\PropertySearch\PropertySearchController@search
   */
  async searchAddress(ownerId: number, location: PropertySearchLocation): Promise<PropertySearch> {
    const payload = {
      address: location.address,
      city: location.city,
      state: location.state,
      zip: location.postalCode,
    };
    const response = await this.httpClient.post<HttpResponse<JsonResponse>>(
      `/workspace/${ownerId}/property-search`,
      payload,
    );

    return fromJson(PropertySearch, response.data.data);
  }
}
